import { Box, HStack, IconButton, Shadow, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';

import {
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { CustomerNameLoading } from '../CustomerTableItem/shared/CustomerName';
import { IncomeTaxButtonLoading } from '../CustomerTableItem/shared/IncomeTaxButton';

export const ListLoadingItemMobile: React.FC = () => {
  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy}>
      <VStack space="stack.xxxs" p="inset.xs">
        <CustomerNameLoading />

        <VStack space="stack.nano">
          <HStack space="stack.quarck" justifyContent="space-between">
            <Text variant="semibold">CPF/CNPJ</Text>
            <TextSkeleton />
          </HStack>

          <Box w="full" h="1px" bg="neutral.lightest" />

          <HStack space="stack.quarck" justifyContent="space-between">
            <Text variant="semibold">Cadastro</Text>
            <DoubleTextSkeleton />
          </HStack>

          <Box w="full" h="1px" bg="neutral.lightest" />

          <HStack space="stack.quarck" justifyContent="space-between">
            <Text variant="semibold">Conta de custódia</Text>
            <TextSkeleton />
          </HStack>
        </VStack>

        <HStack alignItems="center" space="stack.nano" justifyContent="space-between">
          <IncomeTaxButtonLoading />
          <IconButton
            testId="customers-table-item-mobile-action"
            icon="ArrowRight"
            iconSize="xxs"
            iconColor="neutral.light"
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
